import { styled } from '@ori-ui/mui';
import { FONT_SANS_ORI } from "../../common";
export var Root = styled('p')(function (_ref) {
  var theme = _ref.theme;
  return {
    alignItems: 'center',
    color: theme.palette.grey.A700,
    display: 'flex',
    fontFamily: FONT_SANS_ORI,
    fontSize: theme.typography.pxToRem(12),
    margin: 0,
    svg: {
      fontSize: theme.typography.pxToRem(20),
      marginRight: theme.spacing(1.5)
    }
  };
});
//# sourceMappingURL=styles.js.map